/**
 * Existing WorkUI application token response returned by the Auth API.
 */
export interface AuthToken {
  token: string;
  expires: number;
  refresh_token: string;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

/**
 * Type guard for the token response returned by the Auth API.
 */
export function isAuthToken(value: unknown): value is AuthToken {
  if (!isRecord(value)) {
    return false;
  }

  const token = value.token;
  const expires = value.expires;
  const refreshToken = value.refresh_token;

  if (typeof token !== "string" || token.length === 0) {
    return false;
  }

  if (typeof expires !== "number" || !Number.isFinite(expires)) {
    return false;
  }

  return typeof refreshToken === "string" && refreshToken.length > 0;
}
